if (!window.__lzGoldMoonCompanionCartUpsellBound) {
  window.__lzGoldMoonCompanionCartUpsellBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-upsell-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const drawer = button.closest('cart-drawer') || document.querySelector('cart-drawer');
    const upsellCard = button.closest('[data-cart-upsell]');
    const errorElement = upsellCard?.querySelector('[data-cart-upsell-error]');

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    upsellCard?.classList.add('is-loading');

    try {
      if (drawer && typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(button);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      const sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender()
        : [];

      sections.forEach((section) => formData.append('sections', section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const addResponse = await fetch(`${routes.cart_add_url}`, config);
      const parsedState = await addResponse.json();

      if (!addResponse.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || window.cartStrings.error);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer-add-on-asset',
          productVariantId: variantId,
          cartData: parsedState,
        });
      }

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(parsedState);
      } else {
        window.location.href = routes.cart_url;
      }
    } catch (error) {
      console.error(error);
      if (errorElement) {
        errorElement.hidden = false;
        errorElement.textContent = error.message || window.cartStrings.error;
      }
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      upsellCard?.classList.remove('is-loading');
    }
  });
}
